import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=7d31406a&scoped=true&"
var script = {}
import style0 from "./welcome.vue?vue&type=style&index=0&id=7d31406a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d31406a",
  null
  
)

export default component.exports